<template>
  <v-select
    :options="options"
    :selectName="selectName"
    :selectId="selectId"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    required
  ></v-select>
</template>

<script>
import carsApi from "@/api/resources/carsApi";
import VSelect from "@/components/VSelect.vue";

export default {
  props: {
    selectName: String,
    selectId: String,
    makeId: { type: [String, Number], default: 0 },
    modelValue: [String, Number],
  },
  emits: ["update:modelValue"],
  components: { VSelect },

  data() {
    return {
      options: [],
    };
  },

  watch: {
    makeId(val) {
      this.getCars(val);
    },
  },

  methods: {
    getCars(makeId) {
      if (makeId < 1) {
        return;
      }
      carsApi.index({ make: makeId }).then((response) => {
        this.options = response.data.map((model) => {
          return { text: model.name, value: model.id };
        });
      });
    },
  },

  created() {
    this.getCars(this.makeId);
  },
};
</script>

<style></style>
